import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IOptionSets } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class OptionSetsApiService {

  abstract getList(entityName: string): Observable<IOptionSets[]>;

}